export enum PayoutAccountStatus {
    ACCOUNT_NOT_EXIST = 'ACCOUNT_NOT_EXIST',
    ACCOUNT_PENDING_TRANSFER_METHOD = 'ACCOUNT_PENDING_TRANSFER_METHOD',
    ACCOUNT_PENDING_ACTIVATION = 'ACCOUNT_PENDING_ACTIVATION',
    ACCOUNT_PENDING_VERIFICATION = 'ACCOUNT_PENDING_VERIFICATION',
    ACCOUNT_UNDER_REVIEW = 'ACCOUNT_UNDER_REVIEW',
    ACCOUNT_ACTIVATED = 'ACCOUNT_ACTIVATED',
    ACCOUNT_DISABLED = 'ACCOUNT_DISABLED',
    ACCOUNT_UNKNOWN_STATUS = 'ACCOUNT_UNKNOW_STATUS',
    ACCOUNT_LOCKED = 'ACCOUNT_LOCKED',
    ACCOUNT_PENDING_REPROCESS = 'ACCOUNT_PENDING_REPROCESS'
}

export enum TaxAccountStatus {
    TAX_RECORD_NOT_EXIST = 'TAX_RECORD_NOT_EXIST',
    TAX_PENDING_APPROVAL = 'TAX_PENDING_APPROVAL',
    TAX_NEED_UPDATE = 'TAX_NEED_UPDATE',
    TAX_INVALID = 'TAX_INVALID',
    TAX_VERIFIED = 'TAX_VERIFIED'
}

export enum PaymentStatus {
    IN_PROGRESS = 'IN PROGRESS',
    FAILED = 'FAILED',
    COMPLETED = 'COMPLETED',
    UNKNOWN = 'UNKNOWN'
}

export enum PayoutTypes {
    NONE = 'NONE',
    CASH = 'CASH',
    VBUCKS = 'VBUCKS'
}

export enum AcceptanceStatus {
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    NO_ACTION = 'NO_ACTION'
}

export enum PayoutAccountTypes {
    OFFLINE = 'OFFLINE',
    HYPERWALLET = 'HYPERWALLET',
    BOA = 'BOA'
}

export enum OfflinePaymentAccountStatus {
    VALID_OFFLINE_ACCOUNT = 'VALID_OFFLINE_ACCOUNT',
    INVALID_OFFLINE_ACCOUNT = 'INVALID_OFFLINE_ACCOUNT'
}

export enum BOAPaymentAccountStatus {
    BOA_ACCOUNT_NOT_EXIST = 'BOA_ACCOUNT_NOT_EXIST',
    BOA_ACCOUNT_PENDING_VERIFICATION = 'BOA_ACCOUNT_PENDING_VERIFICATION',
    BOA_ACCOUNT_PRE_ACTIVATED = 'BOA_ACCOUNT_PRE_ACTIVATED',
    BOA_ACCOUNT_ACTIVATED = 'BOA_ACCOUNT_ACTIVATED',
    BOA_ACCOUNT_DISABLED = 'BOA_ACCOUNT_DISABLED',
    BOA_ACCOUNT_LOCKED = 'BOA_ACCOUNT_LOCKED',
    BOA_ACCOUNT_UNKNOWN_STATUS = 'BOA_ACCOUNT_UNKNOWN_STATUS',
    BOA_ACCOUNT_PENDING_REPROCESS = 'BOA_ACCOUNT_PENDING_REPROCESS'
}

export interface TaxRecord {
    recordModifiedOn: string;
    mailingAddressState: string;
    recordIdentityKey: string;
    modifiedAt: string;
    guardianPhoneNumber: string;
    organizationEntity: boolean;
    taxStatus: string;
    legalName: string;
    taxVerified: boolean;
    createdAt: string;
    mailingAddressLine1: string;
    mailingAddressLine2: string;
    profileType: string;
    taxStatusExpiryDate: string;
    paymentHandler: string;
    tin: string;
    addressLine1: string;
    addressLine2: string;
    recordCreatedOn: string;
    payeeId: string;
    addressCity: string;
    uSPerson: boolean;
    individual: boolean;
    rvn: number;
    firstName: string;
    emailStatus: string;
    affiliateUse: string;
    phoneNumber: string;
    foreignTin: string;
    isUSPerson: boolean;
    doingBusinessAsName: string;
    emailSentCount: number;
    addressPostCode: string;
    errorNote: string;
    guardianEmail: string;
    lastName: string;
    guardianFirstName: string;
    mailingAddressPostCode: string;
    tinType: string;
    mailingAddressDifferent: string;
    isIndividual: string;
    retakeBan: string;
    guardianLastName: string;
    mailingAddressCity: string;
    addressCountryCode: string;
    email: string;
    taxTreatyCountryCode: string;
    lastEmailSentTime: string;
    mailingAddressCountryCode: string;
    dateOfBirth: string;
    addressState: string;
    paymentErrorCode: string;
    isOrganizationEntity: boolean;
    identityId: string;
}
